import React from "react";
import { Avatar, Divider, Dropdown, Menu } from "antd";
import { UserOutlined, LockOutlined, LogoutOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import confirm from "antd/es/modal/confirm";
// import { useSelector } from "react-redux";
import { RiLockPasswordLine } from "react-icons/ri";

const UserMenu = ({ username, userRole, onChangePassword, onLogout }) => {
     const showLogoutConfirm = () => {
    confirm({
      title: "Are you sure you want to logout?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      
      onOk() {
        onLogout();
      },
      onCancel() {
      console.log("User clicked No");
    },
    });
  };
//   const { users } = useSelector((state) => state.user || {})
//   const isAuth = users?.ROLE_TITLE == "HR" || users?.ROLE_TITLE == "Admin" || users?.ROLE_TITLE == "Accountant" 
  // const items = [
  //   // {
  //   //   key: "username",
  //   //   label: <span style={{ fontWeight: "bold", font:"20px" }}>{username}</span>,
  //   //   // disabled: true,
  //   // },
  //   {
  //     key: "userRole",
  //     label: <span style={{ fontWeight: "bold", font:"20px" }}>Role : {userRole}</span>,
  //     // disabled: true,
  //   },
  //   {
  //     type: "divider",
  //   },
  //   {
  //     key: "changePassword",
  //     icon: <RiLockPasswordLine />,
  //     label: "Change Password",
  //     onClick: onChangePassword,
  //   },
  //   {
  //     key: "logout",
  //     icon: <LogoutOutlined />,
  //     label: <span className="text-red-500  font-bold  "> Logout</span>,
  //     onClick: () => showLogoutConfirm(onLogout)
  //   },
  // ];
  return (
    <Dropdown
      // menu={{ items }}
      placement="bottomRight"
      trigger={["click"]}
      dropdownRender={() => (
        <div
          className="
            w-64
            rounded-xl
            shadow-lg
            bg-white
            dark:bg-gray-900
            text-gray-800
            dark:text-white
          "
        >
          {/* Header */}
          <div className="flex items-center gap-3 p-4">
            <Avatar
              size={42}
              icon={<UserOutlined />}
              className="bg-[#634B7D]"
            />
            <div>
              <p className="font-semibold">{username}</p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {userRole}
              </p>
            </div>
          </div>

          <Divider className="my-0 dark:border-gray-700" />

          {/* Actions */}
          <div className="p-2 space-y-1">
            <button
              onClick={onChangePassword}
              className="
                w-full
                flex items-center gap-3
                px-3 py-2
                rounded-md
                hover:bg-gray-100
                dark:hover:bg-gray-800
              "
            >
              <RiLockPasswordLine />
              Change Password
            </button>

            <button
              onClick={showLogoutConfirm}
              className="
                w-full
                flex items-center gap-3
                px-3 py-2
                rounded-md
                text-red-500
                hover:bg-red-50
                dark:hover:bg-red-900/20
              "
            >
              <LogoutOutlined />
              Logout
            </button>
          </div>
        </div>
      )}

    >
      <span className="flex gap-3 justify-center items-center">
        <Avatar style={{ backgroundColor: '#634B7D' , cursor : 'pointer' }} size={40}  icon={<UserOutlined />} />
       <span className='font-semibold flex hover:cursor-pointer  h-fit text-sm md:text-xl bg-sunsetOrange rounded-md text-black px-2'>{username} </span>

      </span>
       {/* <span className='font-semibold flex hover:cursor-pointer  text-sm md:text-2xl bg-sunsetOrange rounded-md text-black px-2'>{username}</span> */}
    </Dropdown>
  );
};

export default UserMenu;
